import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchbarService {

  search = false;

  constructor() { }

  setSearchBar(search){
    this.search = search;
  }

  getSearchBar(){
    return this.search;
  }

}
